import React from 'react';
import UserLayout from '@layout/user/home/UserLayout';
import RealTimeExchange from '@comp/user/default/realtime/RealTimeExchange';
import SEO from '@comp/SEO';

function UserRealTime() {
  return (
    <SEO>
      <UserLayout>
        <RealTimeExchange />
      </UserLayout>
    </SEO>
  );
}

export default React.memo(UserRealTime);
